<template>
  <simple-page header="单位周报"
               @query="query">
    <template #buttons>
      <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
    </template>
    <template #form>
      <el-form ref="queryForm" :model="queryForm" inline>
        <el-form-item label="所属单位" prop="compId">
          <comp-select v-model="queryForm.compId" collapse-tags></comp-select>
        </el-form-item>
        <el-form-item label="统计周" prop="dates">
          <el-date-picker v-model="queryForm.startDate" type="week"
                          @change="query"
                          :clearable="false"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          align="right"></el-date-picker>
        </el-form-item>
      </el-form>
    </template>

    <el-table stripe :data="records" :border="true" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center" fixed></el-table-column>
      <el-table-column prop="compName" label="单位名称" min-width="130"></el-table-column>
      <el-table-column prop="deviceCount" label="设备数量" align="center" min-width="80"></el-table-column>
      <el-table-column prop="onlineCount" label="正常运行数量" align="center" min-width="80"></el-table-column>
      <el-table-column label="故障设备数量" align="center" min-width="80" v-slot="{row}">
        {{((row.deviceCount || 0) - (row.onlineCount || 0)) || '--' }}
      </el-table-column>
    </el-table>
    <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect";
import CodeSelect from "@/components/base/CodeSelect.vue";
import SessionStore from "@/utils/SessionStore";
import * as querystring from "querystringify";
import SimplePage from "@/components/page/SimplePage.vue";
export default {
  components: {SimplePage, CodeSelect, CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      storeKey: "device-month-info",
      queryForm: {
        compId: null,
        startDate: null,
        endDate: '',
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    let dt = new Date();
    dt.setTime(dt.getTime() - 3600 * 1000 * 24 * (dt.getDay() - 1));
    this.queryForm.startDate = dt.format("yyyy-MM-dd");
    let params = SessionStore.getObjectAndClear(this.storeKey);
    if(!!params) {
      this.queryForm = params;
    }
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-day-info/comp-week-list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    download() {
      this.$message.info("正在开发...");
      // let params = querystring.stringify(this.queryForm || {});
      // window.open(this.globalConfig.apiRoot+"/device-day-info/export?"+params);
    }
  }
}
</script>

<style scoped>

</style>